import { registerModule } from '../../core/module.js';
import { Dashboard, Reports } from './Reports.js';

/** The dashboard the owner opens on a phone, and every report. */
export default registerModule({
  id: 'reports',
  order: 60,
  nav: [
    { to: '/today', labelKey: 'nav.dashboard', icon: '📊', group: 'money', permission: 'reports.dashboard', order: 1, primary: 2, hintKey: 'nav.hintDashboard' },
    { to: '/reports', labelKey: 'nav.reports', icon: '📈', group: 'money', permission: 'reports.sales', order: 3, primary: 7, hintKey: 'nav.hintReports' },
  ],
  routes: [
    { path: '/today', element: <Dashboard />, permission: 'reports.dashboard', titleKey: 'dash.title' },
    { path: '/reports', element: <Reports />, permission: 'reports.sales', titleKey: 'reports.title' },
  ],
});
